var map = {
	"./add.svg": 38195,
	"./add_active.svg": 14130,
	"./add_tabs.svg": 23242,
	"./ai.svg": 12445,
	"./ai_active.svg": 1715,
	"./alfred.svg": 39703,
	"./android.svg": 83402,
	"./android_active.svg": 19405,
	"./apple.svg": 31659,
	"./arrow.svg": 60977,
	"./arrow_alt.svg": 70021,
	"./article.svg": 19265,
	"./article_active.svg": 41548,
	"./askwise_logo.svg": 87431,
	"./audio.svg": 88066,
	"./back.svg": 57980,
	"./blank.svg": 28270,
	"./book.svg": 7088,
	"./broken.svg": 62478,
	"./broken_active.svg": 48851,
	"./cache_failed.svg": 30760,
	"./cache_ready.svg": 79204,
	"./cache_retry.svg": 45443,
	"./calendar.svg": 18694,
	"./check.svg": 17153,
	"./check_active.svg": 97849,
	"./clear.svg": 19211,
	"./click.svg": 77532,
	"./close.svg": 8508,
	"./cloud.svg": 80350,
	"./cloud_active.svg": 34738,
	"./day.svg": 15143,
	"./default_collection.svg": 80120,
	"./default_collection_active.svg": 39933,
	"./dev.svg": 33715,
	"./dev_active.svg": 65922,
	"./diamond.svg": 36098,
	"./diamond_active.svg": 91671,
	"./document.svg": 91526,
	"./download.svg": 74063,
	"./dropbox.svg": 35614,
	"./dropbox_active.svg": 65445,
	"./duplicates.svg": 63433,
	"./duplicates_active.svg": 96533,
	"./edit.svg": 94659,
	"./edit_active.svg": 44428,
	"./exit.svg": 40668,
	"./export.svg": 8290,
	"./export_active.svg": 94731,
	"./extension.svg": 1250,
	"./extension_active.svg": 22773,
	"./facebook.svg": 70191,
	"./fonts.svg": 2657,
	"./fonts_active.svg": 56982,
	"./fullscreen.svg": 80968,
	"./fullscreen_active.svg": 33199,
	"./gdrive.svg": 29464,
	"./gdrive_active.svg": 66424,
	"./github.svg": 191,
	"./google.svg": 43484,
	"./help.svg": 35166,
	"./hide.svg": 17925,
	"./highlights.svg": 9285,
	"./history.svg": 58294,
	"./history_active.svg": 36903,
	"./hotkey.svg": 85329,
	"./ifttt.svg": 53483,
	"./image.svg": 86692,
	"./image_active.svg": 67491,
	"./import.svg": 43929,
	"./import_active.svg": 51936,
	"./inbox.svg": 44514,
	"./inbox_active.svg": 22371,
	"./info.svg": 8506,
	"./install.svg": 19269,
	"./install_active.svg": 96585,
	"./integrations.svg": 31379,
	"./integrations_active.svg": 26287,
	"./like.svg": 61223,
	"./like_active.svg": 34908,
	"./like_outline.svg": 74871,
	"./link.svg": 40183,
	"./link_active.svg": 27454,
	"./lock.svg": 83274,
	"./markdown.svg": 35744,
	"./menu.svg": 46425,
	"./micro_add.svg": 46829,
	"./micro_ai.svg": 59238,
	"./micro_arrow.svg": 41698,
	"./micro_article.svg": 43603,
	"./micro_audio.svg": 41514,
	"./micro_book.svg": 38617,
	"./micro_broken.svg": 29453,
	"./micro_cache_failed.svg": 63565,
	"./micro_calendar.svg": 94452,
	"./micro_close.svg": 8465,
	"./micro_cloud.svg": 35825,
	"./micro_colapse.svg": 84163,
	"./micro_comment.svg": 92425,
	"./micro_document.svg": 11185,
	"./micro_download.svg": 22322,
	"./micro_duplicate.svg": 4075,
	"./micro_edit.svg": 30182,
	"./micro_expand.svg": 47559,
	"./micro_image.svg": 94992,
	"./micro_important.svg": 62290,
	"./micro_important_active.svg": 54636,
	"./micro_link.svg": 13788,
	"./micro_list.svg": 53223,
	"./micro_next.svg": 9161,
	"./micro_open.svg": 10773,
	"./micro_progress.svg": 79037,
	"./micro_public.svg": 32250,
	"./micro_reminder.svg": 80943,
	"./micro_screenshot.svg": 1056,
	"./micro_search.svg": 84760,
	"./micro_tag.svg": 68267,
	"./micro_tune.svg": 24600,
	"./micro_user.svg": 92869,
	"./micro_video.svg": 23683,
	"./more.svg": 47777,
	"./more_horizontal.svg": 75528,
	"./move_to.svg": 16349,
	"./move_to_active.svg": 68641,
	"./new_bookmark.svg": 24803,
	"./new_collection.svg": 1966,
	"./new_collection_active.svg": 21302,
	"./next.svg": 76043,
	"./night.svg": 13376,
	"./note.svg": 30652,
	"./open.svg": 62454,
	"./public.svg": 17071,
	"./public_active.svg": 69618,
	"./readwise.svg": 26121,
	"./refresh.svg": 66140,
	"./reminder.svg": 15982,
	"./reminder_active.svg": 27312,
	"./reminder_add.svg": 83605,
	"./rss.svg": 96675,
	"./search.svg": 17157,
	"./select_all.svg": 61101,
	"./select_none.svg": 32478,
	"./settings.svg": 41143,
	"./settings_active.svg": 51591,
	"./share.svg": 47848,
	"./sharing.svg": 28005,
	"./sharing_active.svg": 99096,
	"./show.svg": 21902,
	"./show_active.svg": 92275,
	"./sidebar.svg": 14457,
	"./sidebar_alt.svg": 80971,
	"./sidebar_alt_active.svg": 7751,
	"./slack.svg": 35691,
	"./sort_+lastUpdate.svg": 71556,
	"./sort_+lastUpdate_active.svg": 55584,
	"./sort_-created.svg": 88585,
	"./sort_-created_active.svg": 55449,
	"./sort_-domain.svg": 86172,
	"./sort_-domain_active.svg": 9010,
	"./sort_-lastUpdate.svg": 49458,
	"./sort_-lastUpdate_active.svg": 63679,
	"./sort_-title.svg": 32722,
	"./sort_-title_active.svg": 11786,
	"./sort_created.svg": 60242,
	"./sort_created_active.svg": 41303,
	"./sort_domain.svg": 17242,
	"./sort_domain_active.svg": 30711,
	"./sort_rating.svg": 51515,
	"./sort_rating_active.svg": 26885,
	"./sort_score.svg": 12138,
	"./sort_score_active.svg": 31381,
	"./sort_sort.svg": 78640,
	"./sort_sort_active.svg": 2485,
	"./sort_title.svg": 28134,
	"./sort_title_active.svg": 21409,
	"./tag.svg": 42179,
	"./tag_active.svg": 56809,
	"./trash.svg": 70364,
	"./trash_active.svg": 74680,
	"./twitter.svg": 35414,
	"./twitter_outline.svg": 72123,
	"./type.svg": 4641,
	"./upload.svg": 4217,
	"./upload_active.svg": 41778,
	"./user.svg": 41191,
	"./user_active.svg": 94342,
	"./video.svg": 82241,
	"./video_active.svg": 64808,
	"./view_grid.svg": 62725,
	"./view_grid_active.svg": 14720,
	"./view_list.svg": 4517,
	"./view_masonry.svg": 97038,
	"./view_simple.svg": 43472,
	"./vkontakte.svg": 4509,
	"./web.svg": 45322,
	"./web_active.svg": 89497,
	"./youtube.svg": 33588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42125;